import { Typography } from "@mui/material";
import React from "react";

const FreeText = ({ freeText }: { freeText: string }): React.JSX.Element => (
  <React.Fragment>
    <Typography variant="h6" color="initial" sx={{ mb: 1 }}>
      Meine Themenwünsche
    </Typography>
    <Typography variant="body1" color="initial">
      {freeText.length > 0 ? freeText : "keine Angabe"}
    </Typography>
  </React.Fragment>
);

export default FreeText;
